import getObject from './getObject'

const getObjectId = (objects, path) => {
  const object = getObject(objects, path)

  return object && object.id
}
export default getObjectId
